import { render } from "./testTemplateTaskEdit.vue?vue&type=template&id=271ce525&scoped=true&ts=true"
import script from "./testTemplateTaskEdit.vue?vue&type=script&lang=ts"
export * from "./testTemplateTaskEdit.vue?vue&type=script&lang=ts"

import "./testTemplateTaskEdit.vue?vue&type=style&index=0&id=271ce525&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271ce525"]])

export default __exports__